import { OrganizationRiderListItem } from '@uzurv/rideWss/clara';

export class OrganizationRiderListItemUtil {
  static isItineraryCreationEnabled(item: OrganizationRiderListItem) {
    const isRideNowEnabled = item.organizationServiceLevels.some(level => level.rideNowEnabled);
    const isScheduledEnabled = item.organizationServiceLevels.some(level => level.scheduledEnabled);
    const isWillCallEnabled = item.organizationServiceLevels.some(level => level.willCallEnabled);

    return item.riderWebBookingEnabled && item.proofed && (isRideNowEnabled || isScheduledEnabled || isWillCallEnabled);
  }
}
